//some comments

import create, { GetState, SetState } from "zustand";

import authSlice, { AuthStateType } from "./auth";

type StateFromFunctions<T extends [...any]> = T extends [infer F, ...infer R]
  ? F extends (...args: any) => object
    ? StateFromFunctions<R> & ReturnType<F>
    : unknown
  : unknown;

export type StoreSlice<T extends object, E extends object = T> = (
  set: SetState<E extends T ? E : E & T>,
  get: GetState<E extends T ? E : E & T>
) => T;

export type StoreType = StateFromFunctions<[typeof authSlice]>;

const useStore = create<StoreType>((set, get) => ({
  ...authSlice(
    set as unknown as SetState<AuthStateType>,
    get as GetState<AuthStateType>
  ),
}));

export default useStore;
